//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import SplitPane from 'vue-splitpane';
Vue.component('SplitPane', SplitPane);
export default {
  mounted: function mounted() {
    // 加载完成后显示提示
    this.showInfo();
  },
  methods: {
    // 显示提示
    showInfo: function showInfo() {
      this.$notify({
        title: '提示',
        message: '在横向或者纵向的分割线上拖拽调整分区大小'
      });
    }
  }
};